<template>
    <router-view/>
</template>

<script>
import store, {ENROLMENT_RESPONSE_NAMESPACE} from '@/common/store';
import response, {INIT_ENROLMENT_DATA} from '@/common/store/modules/enrolment/response.js';
import {createNamespacedHelpers} from 'vuex';
import {$showErrorPage} from '@common/utils/errorPage.js';
import SimpleErrorMessage from '@common/views/SimpleErrorMessage.vue';
import i18n from '@/common/i18n.js';
import {emitGaPageView} from '@common/utils/useAnalytics.js';

const {mapActions, mapGetters, mapState} = createNamespacedHelpers('response');

if (!store.state[ENROLMENT_RESPONSE_NAMESPACE]) {
    store.registerModule(ENROLMENT_RESPONSE_NAMESPACE, response);
}

export default {
    name: 'responseResponse',
    async beforeRouteEnter(to, from, next) {
        const {cardId, surveyReferenceNo, serviceId, isPreview, previewMode, r} = to.query;

        try {
            await store.dispatch(`${ENROLMENT_RESPONSE_NAMESPACE}/${INIT_ENROLMENT_DATA}`, {
                surveyReferenceNo: surveyReferenceNo,
                receiverReferenceNo: r,
                provider: serviceId,
                isMasking: false,
                isPreview: isPreview,
                previewMode: previewMode,
            });

            next();
        } catch (e) {
            if (e instanceof Error) {
                console.log(e);
                e.message = i18n.t('common_scriptError');
            }

            $showErrorPage({component: SimpleErrorMessage, payload: {message: e.message}});
        }
    },

    created(){
        emitGaPageView(this.$route);
    }
};
</script>
